const initialState = {
  activeStep: 'registrationStep-1',
  propertyID: null,
  showRegistration: false,
  showPublish: false,
  creatingProperty: false,
  maxSteps: 8,
  listingSupervision: null,
  owners: {
    contactsLoading: false,
    contacts: [],
    selectedContacts: [],
    modalOpen: false,
    creatingContact: false,
  },
  location: {
    searchType: 'address',
    selectedAddress: null,
    selectedPropertyType: null,
    propertyFields: {},
  },
  duplicatePropertyCheck: {
    isLoading: false,
    isDuplicate: false,
    error: null,
  },
  propertyData: null,
  propertyDataLoading: false,
  characteristics: {
    // 'idle' | 'loading' | 'success' | 'error'
    schemaStatus: 'idle',
    schema: null,
    // Flat map of field values keyed by field `name` (number inputs, counters, radio selects)
    values: {},
    // Array of selected tag ids (checkbox widget)
    tags: [],
  },
  development: {
    membershipType: 'notPartOf',
    searchQuery: '',
    selectedDevelopment: null,
    constructionYear: { year: null, month: null },
    amenities: [],
    tagsStatus: 'idle',
    availableTags: [],
    developmentTagsSnapshot: [],
    propertyTagsSnapshot: [],
    restoringTags: false,
    hasDevelopments: null,
  },
  amenities: {
    // 'idle' | 'loading' | 'success' | 'error'
    schemaStatus: 'idle',
    schema: null,
    // Flat map of radio field values keyed by field `name`
    values: {},
    // Array of selected tag ids (checkbox widgets)
    tags: [],
  },
  pricing: {
    cotization: {
      // 'idle' | 'loading' | 'success' | 'error'
      schemaStatus: 'idle',
      schema: null,
      // Updated from cotization_schema and cotization/price_position responses.
      quoterUrl: null,
      // Keyed by field name from schema.general_fields.
      // Each entry: { exempt: bool, value: string, period: number|null, selectedCurrency: string|null }
      // period is only relevant for fields that have type_options (e.g. iptu)
      // selectedCurrency is independent per field
      fields: {},
    },
    sale: {
      enabled: false,
      expanded: false,
      price: '',
      // { position, label, label_translated } — from fetchPricePosition or schema
      pricePosition: null,
      // Non-Brazilian companies: price per currency code, e.g. { ARS: '40000', USD: '120' }
      prices: {},
    },
    rent: {
      enabled: false,
      expanded: false,
      price: '',
      pricePosition: null,
      prices: {},
    },
    shortTermRental: {
      enabled: false,
      expanded: false,
      cleaningFee: '',
      // Selected currency code for the cleaning fee (non-Brazilian companies).
      cleaningFeeCurrency: null,
      periods: [],
    },
  },
  description: {
    title: { es: '', en: '', pt: '' },
    htmlContent: { es: '', en: '', pt: '' },
    language: 'es',
    // AI generation: 'idle' | 'loading' | 'success' | 'error'
    aiStatus: 'idle',
    aiGenerated: null,
    aiWasApplied: false,
    aiLength: 2,
    aiStyle: 2,
    aiGuidelines: '',
    isAIAvailable: false,
    wasFullPlanRequested: false,
    isRequestingFullPlan: false,
    // Guards so auto-generation runs only once per language
    autoGenerated: false,
    autoGeneratedEn: false,
  },
  publish: {
    isPublished: false,
  },
  pictures: [],
};

export default initialState;
